export { application, Application, APPLICATION_STATE_SYMBOL, getApplicationState } from './application-state';
export type { IApplicationState } from './application-state';
